module.exports = __webpack_public_path__ + "static/media/4.74976b2d.jpeg";